import { ListContentReportsDto } from "types/dto/ListContentReportsDto";
import { ApiService } from "./apiService";

// Mistakes shoppers reported in what the app wrote about products and ingredients.
export const getContentReports = async (dto: ListContentReportsDto) => {
    const status = dto.status && dto.status !== 'all' ? `&status=${dto.status}` : '';
    const targetType = dto.targetType && dto.targetType !== 'all' ? `&targetType=${dto.targetType}` : '';
    const section = dto.section && dto.section !== 'all' ? `&section=${dto.section}` : '';
    return ApiService.get(`content-reports?page=${dto.page}&size=${dto.size}${status}${targetType}${section}`);
}

export const resolveContentReport = async (reportId: string) => {
    return ApiService.patch(`content-reports/${reportId}/resolve`, {});
}
